module.exports = __webpack_public_path__ + "img/ceec_logo.6735d699.jpg";